var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook_2504903_1_",
    "data-name": "facebook_2504903 (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M15,30H7.5A7.5,7.5,0,0,1,0,22.5V7.5A7.5,7.5,0,0,1,7.5,0h15A7.5,7.5,0,0,1,30,7.5v15A7.5,7.5,0,0,1,22.5,30H19.688A2.344,2.344,0,1,0,15,30Z",
    transform: "translate(0 0)",
    fill: "#3764b9",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M14.063,8.438H22.5A4.219,4.219,0,0,0,22.931.022C22.788.014,22.646,0,22.5,0H7.5A7.5,7.5,0,0,0,0,7.5v15A14.063,14.063,0,0,1,14.062,8.438",
    fill: "#507dd2",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M39.5,23.5A7.5,7.5,0,1,0,47,31V16a7.5,7.5,0,0,1-7.5,7.5",
    transform: "translate(-17 -8.5)",
    fill: "#1e4ba0",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M37.125,13.75a.937.937,0,0,1-.937.938H33.375a.937.937,0,0,0-.937.938v3.75h3.544A.937.937,0,0,1,36.9,20.5l-.563,2.813a.938.938,0,0,1-.919.754H32.438v11.25H27.75V24.063H24.938A.938.938,0,0,1,24,23.125V20.313a.938.938,0,0,1,.938-.937H27.75v-3.75A5.625,5.625,0,0,1,33.375,10h2.813a.937.937,0,0,1,.938.938Z",
    transform: "translate(-12.75 -5.313)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.125111c6106b36b38f624b47f082fb01.svg";
export { ForwardRef as ReactComponent };